/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchEquipmentRegularSchedulesResponseDto { 
    id?: string;
    name?: string | null;
    triggersCount?: number;
    assignedCount?: number;
    createdDate?: string;
    updatedDate?: string | null;
}

